import { render, staticRenderFns } from "./GitInfo.vue?vue&type=template&id=43046dc4&scoped=true"
import script from "./GitInfo.vue?vue&type=script&lang=js"
export * from "./GitInfo.vue?vue&type=script&lang=js"
import style0 from "./GitInfo.vue?vue&type=style&index=0&id=43046dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43046dc4",
  null
  
)

export default component.exports